import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import {
  TextInput,
  SelectInput,
} from "../../components/common/UI/Inputs/InputControls";
import DatePickerComponent from "../../components/common/UI/Inputs/InputControls/DateInput.jsx";
import { useSelector, useDispatch } from "react-redux";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { masterActions, authActions, findInmatesActions, myContactsActions } from "../../_store";
import findInmatesSchema from "../../validation/findInmatesSchema";
import useDraft from '../../components/common/autoSaveDraftMsg/useDraft';
import { decryptDataInviteLink } from "../../utils/encryptDecrypt";
import ConfirmationModal from "../../components/PopupComponent/ConfirmationModal.jsx";
import relationshipSchema from "../../validation/findInmatesconnectSchema.js";
import translations from '../../config/TranslateFile.jsx'
import { Modal } from "bootstrap";

import NotificationService from "../../ui/ui-modal-notification.js";
import { ReactNotifications } from "react-notifications-component";
import { EventLog } from "../../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../../utils/routeTracker.js";
import FindInmatesTable from "./FindInmatesTable.jsx";
import findInmatesIDSchema from "../../validation/findInmatesIDSchema.js";
import { getStoredValue, setStoredValue } from "../../_helpers/storagehelper.js";

const FindInmates = () => {
  const dispatch = useDispatch();
  const [stateList, setStateList] = useState([]);
  const [errors, setErrors] = useState({});
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { facilityDrpList, facilityStateList } = useSelector(
    (state) => state.master
  );
  const [errorMessage, setErrorMessage] = useState({});
  const [facilityDisabled, setFacilityDisabled] = useState(true);
  const [InviteLinkErrorMsg, setInviteLinkErrorMsg] = useState("");
  const [isInvitePopup, setIsInvitePopup] = useState(false);
  const [isInviteModal, setIsInviteModal] = useState(false);
  const [isInviteLinkErrorModal, setisInviteLinkErrorModal] = useState(false);
  const [inviteInmateMsg, setInviteInmateMsg] = useState("");
  const [isInviteInmateModal, setIsInviteInmateModal] = useState(false);
  const [pendingApproval, setpendingApproval] = useState(false);
  const maxDate = new Date();
  //const maxDate = new Date(today.setFullYear(today.getFullYear() - 18));
  const navigate = useNavigate();
  const UserId = getStoredValue("userID")
  const currentLang = translations();
  const [isshowSearchResult, setIsShowSearchResult] = useState(false);
  const [findInmate, setFindInmate] = useState({});
  const [activeTab, setActiveTab] = useState('FindByNumber');
  const findInmateInitial = {
    UserID: UserId,
    StateID: 0,
    FacilityID: 0,
    FacilityName: 0,
    UserFirstName: "",
    UserLastName: "",
    Dob: "",
    InmatesGender: 0,
    InmateNo: "",
    SortField: "",
  }

  const [findInmates, setFindInmates] = useState(findInmateInitial);

  const [inmateKioskInvite, setInmateKioskInvite] = useState({});

  const InmateDetailsInitial = {
    relationship: "",
    PUIConnectionID: "",
    InmatesId: 0,
    InmateResidentID: 0,
    FacilityID: 0,
    FacilityName: 0,
    InmateInvitePublicUserID: 0,
    userID: getStoredValue("userID"),
    action: 1,
    isSALoginAsPU: 0,
  };

  const [inmateDetail, setInmateDetail] = useState(InmateDetailsInitial);

  const location = useLocation();
  const { setIsSaveDraftModified } = useDraft();
  useEffect(() => {
    const savedDraft = getStoredValue('draft');
    if (savedDraft != null) {
      setIsSaveDraftModified(true);
    }
  }, [setIsSaveDraftModified]);



  const relationshipCancelClick = () => {
    dispatch(findInmatesActions.clearEmailResponse());
    setErrorMessage({});
    setIsInviteModal(false);
    setInmateDetail(InmateDetailsInitial);
    setFindInmates(findInmateInitial);
    navigate("/public/FindInmates");
    storeCurrentRoute("/public/FindInmates");
    setFacilityDisabled(false);
    // setFindInmates((prevState) => ({
    //   ...prevState,
    //   FacilityID: inmateKioskInvite.FacilityID,
    //   FacilityName:inmateKioskInvite?.FacilityName,
    //   UserID: UserId,
    //   StateID: inmateKioskInvite.StateID,
    //   UserFirstName: inmateKioskInvite.FirstName,
    //   UserLastName: inmateKioskInvite.LastName,
    //   Dob: inmateKioskInvite.DOB,
    //   InmatesGender: 0,
    //   InmateNo: inmateKioskInvite.InmateResidentId,
    //   SortField: ""
    // }));

    setFindInmates({
      ...findInmateInitial,
      FacilityID: inmateKioskInvite.FacilityID,
      FacilityName: inmateKioskInvite?.FacilityID,
      UserID: UserId,
      StateID: inmateKioskInvite.StateID,
      UserFirstName: inmateKioskInvite.FirstName,
      UserLastName: inmateKioskInvite.LastName,
      Dob: inmateKioskInvite.DOB,
      InmatesGender: 0,
      InmateNo: inmateKioskInvite.InmateResidentId,
      SortField: ""
    });


  };


  // This function closes the modal
  const closeModal = () => {
    setIsInviteModal(false);
    relationshipCancelClick();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage({});

    // Clear existing input-error classes
    if (document?.getElementsByClassName("input-error").length !== 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }
    const { error } = relationshipSchema(inmateDetail);

    if (error?.details) {
      error?.details.forEach((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [e?.path[0]]: e?.message,
        }));
        document
          .querySelector(`input[name=${path[0]}]`)
          ?.classList.add("input-error");
      });
      return;
    } else {
      // Close the modal first before dispatching
      const modalElement = document.getElementById("modalDialog1");
      const modalInstance = Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      }

      setIsInviteModal(false);

      // Now dispatch the action after closing the modal
      const mergedInmateDetail = {
        ...inmateDetail,
        PUIConnectionID: inmateKioskInvite.PUIConnectionID,
        InmatesId: inmateKioskInvite.InmateID,
        InmateResidentID: inmateKioskInvite.InmateResidentId,
        FacilityID: inmateKioskInvite.FacilityID,
        InmateInvitePublicUserID: inmateKioskInvite.InmateInvitePublicUserID,
        userID: getStoredValue("userID"),
        RelationShip: inmateDetail.relationship
      };

      setFindInmates((prevState) => ({
        ...prevState,
        FacilityID: inmateKioskInvite.FacilityID,
        UserID: UserId,
        StateID: inmateKioskInvite.StateID,
        UserFirstName: inmateKioskInvite.FirstName,
        UserLastName: inmateKioskInvite.LastName,
        Dob: inmateKioskInvite.DOB,
        InmatesGender: 0,
        InmateNo: inmateKioskInvite.InmateResidentId,
        SortField: ""
      }));
      showLoader();
      dispatch(
        findInmatesActions.PublicUserSearchInmate(findInmates)
      )
        .then((response) => {
          if (response.payload) {
            dispatch(
              findInmatesActions.PublicInmateConnectionRequest(mergedInmateDetail)
            ).then((response) => {
              hideLoader();
              var PublicInmateConnectionRequestResponse = response?.payload;

              if (PublicInmateConnectionRequestResponse !== undefined && PublicInmateConnectionRequestResponse !== null && PublicInmateConnectionRequestResponse.length !== 0) {
                if (PublicInmateConnectionRequestResponse === 1) {
                  dispatch(findInmatesActions.clearEmailResponse());
                  NotificationService({
                    title: currentLang?.Message,
                    message: currentLang?.FindInmatePopContent?.Request_sent_Success,
                    type: "success", // can be 'success', 'danger', 'info', 'warning'
                  });
                }
                else if (PublicInmateConnectionRequestResponse === -1) {
                  dispatch(findInmatesActions.clearEmailResponse());
                  NotificationService({
                    title: currentLang?.Message,
                    message: currentLang?.FindInmatePopContent?.Error,
                    type: "warning", // can be 'success', 'danger', 'info', 'warning'
                  });
                }
                else if (PublicInmateConnectionRequestResponse === -2) {
                  setIsInvitePopup(true);
                  setIsInviteInmateModal(true);
                  setInviteInmateMsg(currentLang?.FindInmatePopContent?.Already_in_Request);
                }
                else if (PublicInmateConnectionRequestResponse === -3) {
                  dispatch(findInmatesActions.clearEmailResponse());
                  setIsInviteInmateModal(true);
                  setInviteInmateMsg(currentLang?.FindInmatePopContent?.You_Couldnt_Cancel_Request);
                }
                else if (PublicInmateConnectionRequestResponse === -4) {
                  dispatch(findInmatesActions.clearEmailResponse());
                  setIsInviteInmateModal(true);
                  setInviteInmateMsg(currentLang?.FindInmatePopContent?.You_Couldnt_Request_Again);
                }
                else if (PublicInmateConnectionRequestResponse === -6) {
                  dispatch(findInmatesActions.clearEmailResponse());
                  setIsInviteInmateModal(true);
                  setInviteInmateMsg(currentLang?.FindInmatePopContent?.Contact_Restricted);
                }
                if (Array.isArray(stateList)) {
                  const filteredState = stateList.filter((item) => item.value === parseInt(inmateKioskInvite.StateID));
                  if (filteredState.length === 1) {
                    const data = filteredState[0];
                    handleSelectChange(data, "StateID")
                  }
                }
                if (Array.isArray(facilityDrpList)) {
                  const filteredFacility = facilityDrpList.filter((item) => item.value === parseInt(inmateKioskInvite.FacilityName));
                  if (filteredFacility.length === 1) {
                    const data = filteredFacility[0];
                    handleSelectChange(data, "FacilityID")
                  }
                }
                setIsInviteModal(false);
                const searchParams = new URLSearchParams(location.search);
                const inviteLink = searchParams.get("InviteLink");
                if (inviteLink !== null && !inmateKioskInvite.hdnApprovalRequiredForConnectionRequest) {
                  navigate("/public/WriteMessage?InviteLink=" + encodeURIComponent(inviteLink));
                  storeCurrentRoute("/public/WriteMessage?InviteLink=" + encodeURIComponent(inviteLink));
                } else {
                  navigate("/public/FindInmates");
                  storeCurrentRoute("/public/FindInmates");
                }
              }
            })
          }
        });
      setInmateDetail(InmateDetailsInitial);
    }
  };

  // Handle input change
  const handleChange1 = (e) => {
    const { name, value } = e.target;

    // Allow only alphabetic characters and spaces (no filtering of spaces)
    let updatedValue = value.replace(/[^a-zA-Z\s]/g, ''); // Remove non-alphabet characters, but allow spaces

    // Update state for the form input field
    setInmateDetail((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };

  // Invite the New Inmate
  useEffect(() => {
    // Extract query parameters
    const searchParams = new URLSearchParams(location.search);
    //const isRegisterAsMobile = searchParams.get("IsRegisterAsMobile");
    //const isRedirectedInvitedURL = searchParams.get("IsRedirectedInvitedURL");
    if ([...searchParams.keys()].length > 0) {
      const inviteLink = searchParams.get("InviteLink");
      if (inviteLink !== null && inviteLink.trim() !== "") {
        setStoredValue("IsInvitedURL", false);
        const decodedInviteLink = decryptDataInviteLink(decodeURIComponent(inviteLink.trim()));
        if (decodedInviteLink == "") {
          return;
        }
        const inviteLinkInfo = decodedInviteLink.split('&');
        // Assuming the first part is InmateID and the second part is InviteGUID
        const inmateID = inviteLinkInfo[0];
        const inviteGUID = inviteLinkInfo[1];
        let InmateInvitePublicUserID = 0;
        let StateID = 0;
        let PUIConnectionID = 0;
        // Perform the action with the decoded data
        dispatch(
          authActions.InviteLink({
            InmateID: parseInt(inmateID), // Using decoded InmateID
            InviteGUID: inviteGUID, // Using decoded InviteGUID
            PublicUserId: getStoredValue("userID"), // Set default as per original C# logic
          })
        )
          .then((response) => {
            // Assuming response contains inmate details
            if (response.payload) {
              InmateInvitePublicUserID = response.payload?.InmateInvitePublicUserID;
              StateID = response.payload?.StateNameID;
              PUIConnectionID = response.payload?.PUIConnectionID;
              if (response.payload?.InmateStatus === 0) {
                dispatch(
                  findInmatesActions.UpdateInviteLinkUsageStatus({
                    InmateInvitePublicUserID: parseInt(response.payload?.InmateInvitePublicUserID), // Using decoded InmateID
                    PUIConnectionID: null,
                  })
                )
              }
              else if (response.payload?.PUIConnectionID > 0) {
                dispatch(
                  findInmatesActions.UpdateInviteLinkUsageStatus({
                    InmateInvitePublicUserID: parseInt(response.payload?.InmateInvitePublicUserID), // Using decoded InmateID
                    PUIConnectionID: response.payload?.PUIConnectionID,
                  })
                )
                setIsInviteModal(false);
                switch (response.payload?.ConnectionStatusID) {
                  case 1:
                    setInviteLinkErrorMsg(
                      `Your connection request with ${response.payload?.InmateFullName} is currently pending for admin approval. You will be able to connect after the admin approves it.`
                    );
                    setpendingApproval(false);
                    setisInviteLinkErrorModal(true);
                    break;

                  case 2:
                    setInviteLinkErrorMsg(
                      `${response.payload?.InmateFullName} has an active connection with your account.`
                    );
                    setpendingApproval(true);
                    setisInviteLinkErrorModal(true);
                    break;

                  case 3:
                    setInviteLinkErrorMsg(
                      `${response.payload?.InmateFullName} Connection has been canceled.`
                    );
                    setpendingApproval(false);
                    setisInviteLinkErrorModal(true);
                    break;

                  case 4:
                    setInviteLinkErrorMsg(
                      `${response.payload?.InmateFullName} Connection has been rejected.`
                    );
                    setpendingApproval(false);
                    setisInviteLinkErrorModal(true);
                    break;

                  case 5:
                    setInviteLinkErrorMsg(
                      `${response.payload?.InmateFullName} Connection has been blocked.`
                    );
                    setpendingApproval(false);
                    setisInviteLinkErrorModal(true);
                    break;

                  default:
                    console.warn("Unhandled ConnectionStatusID:", response.payload?.ConnectionStatusID);
                    break;
                }

              }
              else {
                let InmateID = response.payload?.InmateID;
                dispatch(findInmatesActions.InmatesInfo({
                  InmateID: parseInt(response.payload?.InmateID),
                }))
                  .unwrap()  // Unwraps the result to access the payload directly
                  .then((response) => {
                    if (response) {
                      const InmateData = response;
                      setInmateKioskInvite((prevState) => ({
                        ...prevState,
                        FacilityName: InmateData[0]?.FacilityName,
                        FacilityCode: InmateData[0]?.FacilityCode,
                        InmateFullName: InmateData[0]?.InmateFullName,
                        InmateResidentId: InmateData[0]?.InmateResidentId,
                        DOB: InmateData[0]?.DOB,
                        StateID: StateID,
                        FacilityID: InmateData[0]?.FacilityID,
                        FirstName: InmateData[0]?.FirstName,
                        LastName: InmateData[0]?.LastName,
                        InmateID: InmateData[0]?.InmateID,
                        InmateInvitePublicUserID: (InmateData[0].InmateID == InmateID) ? parseInt(InmateInvitePublicUserID) : null,
                        PUIConnectionID: 0,
                        hdnApprovalRequiredForConnectionRequest: InmateData[0].IsApprovalRequiredForConnectionRequest,
                      }));


                      setIsInviteModal(true);
                    }
                  })
                  .catch((error) => {
                    console.error("Error:", error);
                  });

              }

            }
            else {
              setStoredValue("IsInvitedURL", false);
            }
          })
      }
    }
  }, [location]);

  const handlecancelErrorInvite = () => {
    setisInviteLinkErrorModal(false);
  }

  // Update the state only if location.state has valid findInmates data
  useEffect(() => {
    if (location.state?.findInmates) {
      setFindInmates(location.state.findInmates);
      setFacilityDisabled(false);
    }
  }, [location.state]);
  // useEffect(() => {
  //   let stateList = [...stateDrpList];
  //   setStateList(stateList);
  //   hideLoader();
  // }, [stateDrpList]);

  useEffect(() => {
    let stateList = [...facilityStateList];
    setStateList(stateList);
    hideLoader();
  }, [facilityStateList]);


  useEffect(() => {
    showLoader();
    dispatch(masterActions.GetFacilityStateList());
  }, [dispatch]);

  // Trigger facility list loading when state changes
  useEffect(() => {
    if (findInmates.StateID !== 0 && findInmates.StateID !== "") {
      showLoader();
      dispatch(masterActions.GetFacilityList(findInmates.StateID)).then((x) => {
        hideLoader();
        const infoMessage = `Load Facility based on Selected State (State ID - ` + findInmates?.StateID;
        const redirectURL = "---";
        const Response = JSON.stringify(x?.payload);
        const Status = "Facility Count - " + x?.payload?.length;
        if (findInmates?.StateID)
          EventLog(dispatch, infoMessage, redirectURL, Response, Status)
      }
      );
    }
  }, [findInmates.StateID, dispatch]);

  // Common Selectbox Change event
  const handleSelectChange = (selectedOption, fieldName) => {
    const selectedValue = Array.isArray(selectedOption)
      ? selectedOption.map((option) => option.value)
      : selectedOption?.value ?? "";
    if (fieldName === "StateID")
      setErrors({ ...errors, [fieldName]: selectedValue ? '' : currentLang?.ValidationSchema?.Please_Choose_State })
    else if (fieldName === "FacilityName")
      setErrors({ ...errors, [fieldName]: selectedValue ? '' : currentLang?.ValidationSchema?.Please_Choose_Facility })
    setFindInmates((prevState) => ({
      ...prevState,
      [fieldName]: selectedValue,
    }));

    if (fieldName === "FacilityName") {
      setFindInmates((prevState) => ({
        ...prevState,
        FacilityID: selectedValue,
      }));
    }
    setIsShowSearchResult(false);
    if (fieldName === "StateID") {

      if (selectedValue && selectedValue !== 0) {
        const infoMessage = "Selected State Value ";
        const redirectURL = `---`;
        const Response = "Selected State Value - " + selectedValue;
        EventLog(dispatch, infoMessage, redirectURL, Response, "---");
        setFacilityDisabled(false);
      } else {
        const infoMessage = "Un Selected State From dropdown - Find Inmates";
        const redirectURL = `---`;
        const Response = "--- ";
        EventLog(dispatch, infoMessage, redirectURL, Response, "---");
        setFindInmates((prevState) => ({ ...prevState, FacilityID: "", FacilityName: "" }));
        setFacilityDisabled(true);
      }
    }
  };

  // Helper function to validate the date
  const isValidDate = (date) => {
    return !isNaN(new Date(date).getTime());
  };

  // Helper function to calculate the valid max date (18 years before current date)
  const getMaxValidDate = () => {
    const today = new Date();
    const maxDate = new Date();
    maxDate.setFullYear(today.getFullYear() - 18); // 18 years before today
    return maxDate;
  };

  const handleDateChange = (date, fieldName) => {
    const maxValidDate = getMaxValidDate();
    const minValidDate = new Date(1990, 0, 1); // January 1st, 1990

    // Ensure the date is valid
    const formattedDate = date && isValidDate(date)
      ? new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(new Date(date))
      : "";

    // Check if the formatted date is within the valid range
    if (formattedDate) {
      const selectedDate = new Date(date);
      if (selectedDate >= minValidDate && selectedDate <= maxValidDate) {
        // setErrors({ ...errors, [fieldName]: formatDate(formattedDate) ? '' : "Please enter Date of Birth." })
        setFindInmates((prevState) => ({
          ...prevState,
          [fieldName]: formatDate(formattedDate), // Update DOB in the parent state
        }));
      } else {
        // If the date is out of range, reset the input or show a message
        setFindInmates((prevState) => ({
          ...prevState,
          [fieldName]: formatDate(formattedDate), // Reset date if invalid
        }));
      }
    } else {
      // Reset invalid date
      setFindInmates((prevState) => ({
        ...prevState,
        [fieldName]: "",
      }));
    }
  };

  const handleBlur = (e, fieldName) => {
    let { value } = e.target;

    const minDate = new Date(1900, 0, 1);
    const maxDate = getMaxValidDate();

    const inputDate = new Date(value);

    if (value && isValidDate(inputDate)) {
      if (inputDate >= minDate && inputDate <= maxDate) {
        setFindInmates((prevState) => ({
          ...prevState,
          [fieldName]: formatDate(inputDate),
        }));
      } else {
        // setErrors({ ...errors, [fieldName]: "Please enter Date of Birth." })
        setFindInmates((prevState) => ({
          ...prevState,
          [fieldName]: "",
        }));
      }
    } else {
      // setErrors({ ...errors, [fieldName]: "Please enter Date of Birth." })
      setFindInmates((prevState) => ({
        ...prevState,
        [fieldName]: "",
      }));
    }
  };

  const formatDate = (date) => {
    if (date !== null) {
      const d = new Date(date);
      const month = String(d.getMonth() + 1).padStart(2, '0'); // Get month and pad with leading zero if necessary
      const day = String(d.getDate()).padStart(2, '0'); // Get day and pad with leading zero if necessary
      const year = d.getFullYear(); // Get the full year
      return `${month}/${day}/${year}`; // Return the formatted date
    }
    else {
      return null;
    }
  };


  // Find Inmate form common handleChange Event
  const handleChange = (e) => {
    const { name, value } = e?.target;

    if (name === "UserLastName" || name === "UserFirstName") {
      // Allow only alphabets & spaces
      // const alphaValue = value.replace(/[^A-Za-z\s]/g, "");
      const alphaValue = value.replace(/[^A-Za-z\s',\-.*()/_`]/g, "");

      // Determine the error message dynamically
      const errorMessage =
        alphaValue.trim().length > 0
          ? ""
          : name === "UserLastName"
            ? currentLang?.ValidationSchema?.Please_enter_last_name
            : currentLang?.ValidationSchema?.Please_enter_firstname;

      // Update errors
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: errorMessage,
      }));

      // Update form state
      setFindInmates((prev) => ({
        ...prev,
        [name]: alphaValue,
      }));

      return;
    }

    else if (name === "InmateNo") {
      // Allow only digits
      const numericValue = value.replace(/[^0-9]/g, "");

      setErrors({
        ...errors,
        [name]: numericValue?.trim()?.length > 0 ? "" : currentLang?.ValidationSchema?.Please_Enter_Inmate_Id,
      });

      setFindInmates((prev) => ({
        ...prev,
        [name]: numericValue,
      }));
      return;
    }

    // For other fields
    setFindInmates((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  // Validates search input, shows errors if any, or navigates to results page with search data.
  const handleSearch = (e) => {
    e?.preventDefault();
    setErrors({});
    dispatch(findInmatesActions.clearEmailResponse());
    if (document?.getElementsByClassName("input-error").length !== 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    const { error } = activeTab == "FindByNumber" ? findInmatesIDSchema(findInmates) : findInmatesSchema(findInmates);

    if (error?.details) {
      const errorMap = {};

      error.details.forEach((err) => {
        const { path, message } = err;
        if (path[0] == "UserFirstName" || path[0] == "InmateNo" || path[0] == 'UserLastName' || path[0] == 'Dob' || path[0] === "StateID" || (path[0] === "FacilityName" && findInmates.StateID)) {
          errorMap[path[0]] = message;
          // document.querySelector(`input[name=${path[0]}]`)?.classList.add("input-error");
        }
      });

      setErrors(errorMap);
      return;
    } else {
      showLoader();
      setFindInmate(findInmates);
      dispatch(findInmatesActions.PublicUserSearchInmate(findInmates)).then((x) => {
        hideLoader(); setIsShowSearchResult(true);
        const infoMessage = `Bind Inmates - Find Inmate`;
        const redirectURL = `---`;
        const Response = JSON.stringify(x?.payload)
        const Status = "Inmates Count - " + x?.payload?.length;
        EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      })
      // navigate('/public/FindInmatesTables', { state: { findInmates } });
      // storeCurrentRoute("/public/FindInmatesTables");
    }
  };

  const handleRedirectWriteMsg = () => {
    const searchParams = new URLSearchParams(location.search);
    const inviteLink = searchParams.get("InviteLink");
    const decodedInviteLink = decryptDataInviteLink(decodeURIComponent(inviteLink.trim()));
    const inviteLinkInfo = decodedInviteLink.split('&');
    // Assuming the first part is InmateID and the second part is InviteGUID

    const inmatesID = parseInt(inviteLinkInfo[0]);
    const userID = UserId; // Ensure UserID is correctly retrieved from state or props
    const ActiveStatus = 2;
    const SortField = "InmateName asc";
    const InmateLoadPurpose = "Message";
    dispatch(
      myContactsActions.LoadPublicMyContactsDisplay({
        userID,
        inmatesID,
        InmateLoadPurpose,
        ActiveStatus,
        SortField,
      })
    ).then((response) => {
      setisInviteLinkErrorModal(false);
      if (response?.payload?.length > 0) {
        if (pendingApproval) {
          setIsInviteModal(false);
          dispatch(findInmatesActions.clearEmailResponse());
          if (inviteLink !== null && !inmateKioskInvite.hdnApprovalRequiredForConnectionRequest) {
            navigate("/public/WriteMessage?InviteLink=" + encodeURIComponent(inviteLink));
            storeCurrentRoute("/public/WriteMessage?InviteLink=" + encodeURIComponent(inviteLink));
          }
          else {
            navigate("/public/FindInmates");
            storeCurrentRoute("/public/FindInmates");
          }
        }
        else {
          setisInviteLinkErrorModal(false);
        }
      } else {
        navigate("/public/FindInmates");
        storeCurrentRoute("/public/FindInmates");
      }

    });
  }


  // Clear find inmate form
  const handleReset = () => {
    setFindInmates({
      UserID: UserId,
      StateID: 0,
      FacilityID: 0,
      UserFirstName: "",
      UserLastName: "",
      Dob: "",
      InmatesGender: 0,
      InmateNo: "",
      SortField: "",
    });
    setIsShowSearchResult(false);
    setFacilityDisabled(true);
    setErrors({});
    const infoMessage = "Clear Input Fileds - Find Inmate";
    const redirectURL = `---`;
    EventLog(dispatch, infoMessage, redirectURL);
  }

  const handleTabClick = (tabName) => {
    setActiveTab(tabName); setErrors({});
    setIsShowSearchResult(false);
    if (tabName == "FindByNumber") {
      setFindInmates((prevState) => ({
        ...prevState,
        Dob: "", UserLastName: "", UserFirstName: ""
      }));
    }
    else {
      setFindInmates((prevState) => ({
        ...prevState,
        InmateNo: "",
      }));
    }
  };


  return (
    <>
      <ReactNotifications />
      <div className="">
        {/* <div className="card shadow-lg mb-3">
          <div className="card-header">
            <h5 className="find-inmate-head mb-0">
              <i className="fa fa-search"></i>&nbsp;Find Inmates
            </h5>
          </div>
        </div> */}
        <div className="">
          <div className="header-title">
            <h5>
              {/* <i className="fa fa-search me-2"></i> */}

              {currentLang?.FindInmates}
            </h5>
          </div>
        </div>
        <div className="h-100 d-flex justify-content-center align-items-center">
          <div className="card w-100 border-radius-all shadow-sm  mb-5">
            <div className="card-body shadow-sm">
              <div className="row">
                <div className="col-12 mb-3">
                  {/* <div className="alert-blue d-flex align-items-center mb-3 font-size-15">
                    <strong className="me-2">
                      <i className="fa-solid fa-circle-exclamation text-secondary"></i>
                    </strong>
                    <span>
                      {currentLang?.FindInmate?.Inmate_Content}
                    </span>
                  </div> */}
                  {/* <div className="row">
                   
                  </div> */}
                </div>
                {/* <div className="card-body bg-default-gray border-radius-all mt-1 mx-2 mb-3"> */}
                {/* <div className="col-12">
                    <div className="alert-light-red d-flex align-items-center mb-3 font-size-15">
                      <strong className="me-2">
                        <i className="fa-solid fa-circle-exclamation text-success"></i>
                      </strong>
                      <span>
                        {currentLang?.FindInmate?.Inmate_Search_Content}
                      </span>
                    </div>
                  </div> */}

                <div className="row ">

                  <div className="card-body bg-default-gray border-radius-all mt-1 mx-2 ">
                    <div className="row  ">
                      <div className="col-lg-6">
                        <SelectInput
                          options={stateList}
                          value={findInmates.StateID}
                          onChange={(selectedOption) =>
                            handleSelectChange(selectedOption, "StateID")
                          }
                          name="StateID"
                          labelKey="label"
                          valueKey="value"
                          isMulti={false}
                          closeMenuOnSelect={true}
                          isDisabled={false}
                          isClearable={true}
                          placeholder={currentLang?.FindInmate?.Select_State}
                          label={currentLang?.FindInmate?.State}
                          required={true}
                          handleBlur={null} // Handle blur event
                          errorMessage={errors.StateID} // Display errors if any
                        />
                      </div>
                      <div className="col-lg-6">
                        <SelectInput
                          options={facilityDrpList}
                          value={findInmates.FacilityName}
                          onChange={(selectedOption) => handleSelectChange(selectedOption, "FacilityName")}
                          name="FacilityName"
                          labelKey="label"
                          valueKey="value"
                          isMulti={false}
                          isDisabled={facilityDisabled} // Controlled by facilityDisabled state
                          closeMenuOnSelect={true}
                          isClearable={true}
                          placeholder={currentLang?.FindInmate?.Select_Facility}
                          label={currentLang?.FindInmate?.Facility}
                          required={true}
                          errorMessage={errors.FacilityName}
                        />
                      </div>
                    </div>

                  </div>

                  <div className="mt-2 mb-2 border-radius-all  mx-2 ">
                    <div className="row  ">
                      <ul className="nav nav-tabs border-0 ">
                        <li className="nav-item">
                          <button
                            className={`mx-2 nav-link rounded-top ${activeTab === "FindByNumber"
                              ? "bg-danger text-white"
                              : "text-black bg-inmate-tab"
                              }`}
                            onClick={() => handleTabClick("FindByNumber")}
                          >
                            <i className="bi bi-inbox-fill me-1"></i>  {currentLang?.FindInmate?.Find_By_ID}
                          </button>
                        </li>
                        <li className="nav-item">
                          <button
                            className={`nav-link rounded-top ${activeTab === "FindByName"
                              ? "bg-danger text-white"
                              : "text-black bg-inmate-tab"
                              }`}
                            onClick={() => handleTabClick("FindByName")}
                          >
                            <i className="bi bi-send-fill me-1"></i> {currentLang?.FindInmate?.Find_By_Name}
                          </button>
                        </li>
                      </ul>

                    </div>
                  </div>

                  {activeTab !== "FindByNumber" &&
                    <div className="card-body bg-default-gray border-radius-all mt-1 mx-2 mb-3">
                      <div className="row  ">



                        <div className="col-md-6">
                          <div className="mb-2">
                            <TextInput
                              name="UserLastName"
                              id="UserLastName"
                              label={currentLang?.FindInmate?.Last_Name}
                              value={findInmates.UserLastName}
                              handleChange={handleChange}
                              placeholder={currentLang?.FindInmate?.Last_Name}
                              required={true}
                              errorMessage={errors.UserLastName}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleSearch();
                                }
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-2"><TextInput
                            name="UserFirstName"
                            id="UserFirstName"
                            label={currentLang?.FindInmate?.First_Name}
                            value={findInmates.UserFirstName}
                            handleChange={handleChange}
                            placeholder={currentLang?.FindInmate?.First_Name}
                            required={true}
                            errorMessage={errors.UserFirstName}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                handleSearch();
                              }
                            }}
                          /></div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-2">
                            <DatePickerComponent
                              label={currentLang?.FindInmate?.Dob}
                              value={findInmates.Dob}
                              onChange={(date) => handleDateChange(date, "Dob")}
                              handleSearch={handleSearch}
                              name="Dob"
                              minDate={new Date(1900, 0, 1)} // January 1st, 1990
                              maxDate={getMaxValidDate()}
                              required={false}
                              disabled={false}
                              errorMessage={errors}
                              yearDropDown={true}
                              monthDropDown={true}
                              placeholder={currentLang?.FindInmate?.Dob_Placeholder}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleSearch();
                                }
                              }}
                              onBlur={(e) => handleBlur(e, "Dob")}
                            />
                          </div>
                        </div>

                      </div> </div>
                  }

                  {activeTab == "FindByNumber" &&
                    <div className="card-body bg-default-gray border-radius-all mt-1 mx-2 mb-3">
                      <div className="row  ">
                        <div className="col-md-6">
                          <div className="form-group mb-2">
                            <label htmlFor="InmateNo" className="form-label w-100 fs-5 inmate-label">{currentLang?.FindInmate?.Inmate_ID} <span className="text-danger">*</span></label>
                            <input
                              type="text"
                              name="InmateNo"
                              id="InmateNo"
                              className={`form-control  fs-5 ${errors?.InmateNo ? "border-danger" : ""} fw-normal`}
                              value={findInmates.InmateNo}
                              onChange={handleChange}
                              placeholder={currentLang?.FindInmate?.Inmate_ID}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleSearch();
                                }
                              }}
                            />
                            {errors?.InmateNo && (
                              <div className="text-danger fw-700 fs-6 mt-1">
                                {errors?.InmateNo}
                              </div>
                            )}
                          </div>

                        </div>
                      </div>
                    </div>
                  }

                  <div className="col-md-3 mb-2">
                    <div className="d-flex justify-content-start align-items-center mt-1">
                      <button
                        type="submit"
                        className="btn btn-success font-size-14 mb-2 me-2 d-flex align-items-center"
                        onClick={handleSearch}
                      >
                        <i className="fa-solid fa-magnifying-glass me-1"></i>
                        {currentLang?.buttons?.Search}
                      </button>
                      <button
                        type="button"
                        className="btn btn-grey font-size-14 mb-2 d-flex align-items-center"
                        onClick={handleReset}
                      >
                        <i className="fa-solid fa-arrow-rotate-left me-1"></i>
                        {currentLang?.buttons?.Reset}
                      </button>
                    </div>
                  </div>
                </div>
                {loader}
                {/* </div> */}

              </div>
              {isshowSearchResult &&
                <FindInmatesTable findInmate={findInmate} setIsShowSearchResult={setIsShowSearchResult} />
              }
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
        show={isInviteLinkErrorModal}
        showCancelButton={false}
        onConfirm={() => {
          handleRedirectWriteMsg(); // Execute the set action
        }}
        title={currentLang?.Message}
        message={InviteLinkErrorMsg}
        closeButton={false}
        onconfirmname={currentLang?.buttons?.OK}
      />

      <ConfirmationModal
        show={isInviteInmateModal}
        onHide={() => setIsInviteInmateModal(false)}
        onConfirm={() => setIsInviteInmateModal(false)}
        title={currentLang?.Message}
        message={inviteInmateMsg}
        showCancelButton={false}
        onconfirmname={currentLang?.buttons?.OK}
      />

      {/* Modal */}
      <div
        className={`modal fade ${isInviteModal ? "show" : ""}`} // Apply 'show' class to show the modal
        id="modalDialog1"
        tabIndex="-1"
        aria-labelledby="modalDialog1"
        aria-hidden={!isInviteModal} // aria-hidden depends on visibility
        data-bs-backdrop="static" // Prevent closing by clicking outside
        style={{
          display: isInviteModal ? "block" : "none",
          opacity: isInviteModal ? 1 : 0, // Control opacity for fade effect
          transition: 'opacity 0.3s ease-in-out', // Apply fade effect transition
        }}
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{currentLang?.FindInmate?.Add_Relationship}</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <form onSubmit={(e) => {
              e.preventDefault();
              handleSubmit(e);
            }}>
              <div className="modal-body">
                <h5 className="mb-4 text-default-red font-size-14">
                  {currentLang?.FindInmate?.Add_Relationship_Content}
                </h5>
                <div className="row mb-3">
                  <label className="form-label col-form-label fw-300 font-size-15 col-md-4">
                    {currentLang?.FindInmate?.Facility}
                  </label>
                  <div className="col-md-8"><p className="mb-0 col-form-label">{inmateKioskInvite.FacilityName}</p></div>
                </div>
                <div className="row mb-3">
                  <label className="form-label col-form-label fw-300 font-size-15 col-md-4">
                    {currentLang?.FindInmate?.Inmate_ID}
                  </label>
                  <div className="col-md-8"><p className="mb-0 col-form-label">{inmateKioskInvite.InmateResidentId}</p></div>
                </div>
                <div className="row mb-3">
                  <label className="form-label col-form-label fw-300 font-size-15 col-md-4">
                    {currentLang?.FindInmate?.Inmate_Name}
                  </label>
                  <div className="col-md-8"><p className="mb-0 col-form-label">{inmateKioskInvite.InmateFullName}</p></div>
                </div>
                <div className="row mb-3">
                  <label className="form-label col-form-label fw-300 font-size-15 col-md-4">
                    {currentLang?.FindInmate?.Dob}
                  </label>
                  <div className="col-md-8"><p className="mb-0 col-form-label">{inmateKioskInvite.DOB}</p></div>
                </div>
                <div className="row mb-3">
                  <label className="form-label col-form-label fw-300 font-size-15 col-md-4">
                    <span className="text-default-red">*</span> {currentLang?.FindInmate?.Your_Relationship}
                  </label>
                  <div className="col-md-8">
                    <input
                      type="text"
                      name="relationship"
                      className={`form-control`}
                      value={inmateDetail.relationship}
                      onChange={handleChange1}
                      placeholder="Enter Relationship"
                      autoComplete="off"
                      maxLength="20"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevent default form submission
                          e.stopPropagation(); // Stop propagation of the event
                          handleSubmit(e); // Manually call the form submission
                        }
                      }}
                    />

                    {errorMessage.relationship && (
                      <div className="text-danger">
                        {errorMessage.relationship}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={closeModal}
                >
                  {currentLang?.buttons?.Cancel}
                </button>
                <button type="submit" className="btn btn-success" >
                  {currentLang?.buttons?.AddToContacts}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Modal backdrop fade effect directly applied to backdrop */}
      {isInviteModal && (
        <div
          className="modal-backdrop fade"
          style={{
            opacity: 0.9, // Adjust opacity for the backdrop
            transition: 'opacity 0.3s ease-in-out', // Apply transition effect
          }}
        ></div>
      )}
    </>
  );
};

export default React.memo(FindInmates);
